import NavbarLink from "./NavLink";
import { Group, Stack } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

function NavbarLinks({ links, activeLabel, onLinkClick }) {
  const isMobile = useMediaQuery('(max-width: 768px)');

  const handleClick = (fn) => () => {
    fn?.();
    onLinkClick?.();
  };

  if (isMobile) {
    return (
      <Stack gap="xs" w="100%">
        {links.map((e) => (
          <NavbarLink
            key={e.label}
            label={e.label}
            link={e.link}
            onClick={handleClick(e.onClick)}
            isActive={e.label === activeLabel}
          />
        ))}
      </Stack>
    );
  }

  return (
    <Group spacing="xs" align="center" justify="center" w="100%">
      {links.map((e) => (
        <NavbarLink
          className="Nav-links"
          key={e.label}
          label={e.label}
          link={e.link}
          onClick={e.onClick}
          isActive={e.label === activeLabel}
        />
      ))}
    </Group>
  );
}

export default NavbarLinks;
